module.exports = __webpack_public_path__ + "img/arcmet.84137e38.jpg";